export const subscriptions = {
    layout: {
        indexTitle: 'Recorrências',
    },
    hero: {
        // Duas células iguais que também são as abas da lista (emenda de 26/09/2026 à ADR
        // 0018): despesa e receita com o mesmo peso, o mês grande e o ano na legenda. Sem
        // "N recorrências ativas": a frase ocupava uma linha inteira e apagava o anual.
        expenses: 'Despesas',
        income: 'Receitas',
        perYear: '{{amount}} por ano',
        none: 'Nenhuma ainda',
        // A linha que soma (Helenilson, 22/09/2026): receita − despesa por mês. "Sobra"
        // vira "Falta" quando a despesa passa.
        resultLeft: 'Sobra por mês',
        resultShort: 'Falta por mês',
    },
    item: {
        badgeHidden: 'Oculta',
        badgePaused: 'Pausada',
        // Série ignorada (ADR 0169): listada, fora dos totais.
        badgeIgnored: 'Ignorada',
    },
    group: {
        category: 'Categoria',
        source: 'Fonte',
        // Lista plana, que o repositório já entrega em ordem de próxima cobrança. Era "Todas",
        // que ao lado do funil lia como filtro ("todas as recorrências"), não como agrupamento.
        all: 'Data',
    },
    sections: {
        activeRecurring: 'Recorrências ativas',
        paused: 'Pausadas',
        hidden: 'Ocultas',
        noSource: 'Sem fonte',
        noCategory: 'Sem categoria',
        itemCount_one: '{{count}} item',
        itemCount_other: '{{count}} itens',
        perMonth: '{{amount}}/mês',
    },
    action: {
        subNextNear: '{{weekday}}, dia {{day}}',
        subNextFar: 'dia {{date}}',
        enableBillAlert: 'Ativar aviso de cobrança',
        enableBillAlertDesc: 'Avise 1 dia antes pra cancelar a tempo',
        stopAlert: 'Parar de avisar',
        stopAlertDesc: 'Desliga o aviso de cobrança',
        alertOneDayBefore: 'Avisar 1 dia antes',
        alertOneDayBeforeDesc: 'Lembrete 1 dia antes da cobrança',
        unhide: 'Reexibir',
        unhideDesc: 'Voltar a mostrar na lista',
        edit: 'Editar',
        editDesc: 'Valor, frequência, categoria',
        resume: 'Retomar',
        resumeDesc: 'Voltar a gerar ocorrências',
        pause: 'Pausar',
        pauseDesc: 'Parar de gerar novas ocorrências',
        hide: 'Ocultar',
        hideDesc: 'Tirar da lista, segue contando',
    },
    calendar: {
        showA11y: 'Ver calendário',
        hideA11y: 'Voltar para a lista',
        weekdaySun: 'D',
        weekdayMon: 'S',
        weekdayTue: 'T',
        weekdayWed: 'Q',
        weekdayThu: 'Q',
        weekdayFri: 'S',
        weekdaySat: 'S',
        chargesCount_one: '{{count}} cobrança · {{total}}',
        chargesCount_other: '{{count}} cobranças · {{total}}',
        // Na aba de receitas o que cai no mês é entrada, não cobrança.
        incomeCount_one: '{{count}} entrada · {{total}}',
        incomeCount_other: '{{count}} entradas · {{total}}',
        dayAccessibility: 'Dia {{day}}, {{amount}} em cobranças',
        dayIncomeAccessibility: 'Dia {{day}}, {{amount}} em entradas',
        chargesOfMonth: 'Cobranças do mês',
        incomeOfMonth: 'Entradas do mês',
        detailClose: 'Fechar',
        detailCharges: 'Cobranças',
        detailDayTotal: 'Total do dia',
        detailNoCharges: 'Sem cobrança',
        detailNoIncome: 'Sem entrada',
        emptyTitle: 'Nenhuma cobrança no período',
        emptyIncomeTitle: 'Nenhuma entrada no período',
        emptySubtitle: 'Troque o mês ou selecione outro dia para consultar as recorrências.',
    },
    filter: {
        title: 'Filtrar',
        clear: 'Limpar',
        statusLabel: 'Status',
        statusActive: 'Ativas',
        statusPaused: 'Pausadas',
        statusHidden: 'Ocultas',
        applyButton_one: 'Ver {{count}} recorrência',
        applyButton_other: 'Ver {{count}} recorrências',
    },
    newType: {
        title: 'Nova recorrência',
        expense: 'Despesa',
        expenseDesc: 'Assinatura, mensalidade, conta que se repete',
        income: 'Receita',
        incomeDesc: 'Salário, aluguel recebido, pró-labore',
    },
    list: {
        emptyTitle: 'Nenhuma recorrência ainda',
        emptySubtitle: 'Cadastre uma despesa ou receita que se repete (assinatura, mensalidade, salário) e acompanhe aqui o total por mês e por ano.',
        emptyAction: 'Criar recorrência',
        // Vazio de UMA aba (a outra tem itens): fala do tipo, e o botão já cria daquele tipo.
        emptyExpenseTitle: 'Nenhuma despesa recorrente',
        emptyExpenseSubtitle: 'Assinatura, mensalidade, conta que se repete — cadastre e veja o total por mês e por ano.',
        emptyExpenseAction: 'Criar despesa recorrente',
        emptyIncomeTitle: 'Nenhuma receita recorrente',
        emptyIncomeSubtitle: 'Salário, aluguel recebido, pró-labore — cadastre o que entra todo mês e veja quanto sobra.',
        emptyIncomeAction: 'Criar receita recorrente',
    },
    hideDialog: {
        title: 'Ocultar recorrência',
        message: 'Deseja ocultar esta recorrência da lista? Ela continua ativa e contando nas projeções.',
        confirm: 'Ocultar',
    },
};
